var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "a",
        {
          staticClass: "btn",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              return _vm.openSendEmailModal()
            }
          }
        },
        [_vm._v("Send Email")]
      ),
      _vm._v(" "),
      _c("vehicle-recommendation-send-email-modal", {
        attrs: {
          selectedVehicles: this.vehicleId,
          getAllVehicles: this.loadVehicles
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f11ddce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f11ddce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SendEmail.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8f11ddce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SendEmail.vue
// module chunks = 0